import { AssetClassColourArray } from "./enums/AssetClassType";
import { Placements } from "./enums/Placements";
import { GraphColourArray } from "./enums/GraphColours";

class GraphBreakdownController implements angular.IOnInit {
  // Properties are passed to inner components
  public items: { name: string; total: number; color: string }[];
  public chartClass: string;
  public displayCurrency: string; // Possible Enum: DisplayCurrencies or Currencies
  public showLabels: boolean;
  public showIndicators: boolean;

  // Used for this component
  public itemColourArray = GraphColourArray;
  public listPosition: Placements;

  /** @ngInject */
  constructor() {}

  $onInit(): void {
    this.listPosition = this.listPosition || Placements.Left;
  }
}

export const graphBreakdown: angular.IComponentOptions = {
  controller: GraphBreakdownController,
  template: require("./graphbreakdown.component.html"),
  bindings: {
    items: "<",
    displayCurrency: "<",
    listPosition: "<",
    showLabels: "<",
    showIndicators: "<",
    chartClass: "=",
  },
};



// WEBPACK FOOTER //
// ./src/app/common/graphbreakdown.component.ts